import React from 'react';
import VideoJS from '../../common/VideoJS';
import { defaultVideoJSOptions, isVideoType } from '../../../helpers/mediaHelpers';
// Link to large image, display normal size in search results
const ResultMedia = ({image, defaultImage, projection, onImageLoad}) => {
  let displayUrl = defaultImage;
  let displayBig = displayUrl;
  let displayNormal = displayUrl;

  if(image && isVideoType(image)){
    displayUrl = `displayContent.do?uri=${image}`;
    let options = defaultVideoJSOptions(displayUrl);

    return (
      <div className='resultEntryVideo' >
        <VideoJS onLoad={onImageLoad} options={options} projection={projection}/>
      </div>
    );
  }

  if (image) {
    displayUrl = `displayContent.do?uri=${image}`;
    displayBig = displayUrl + '&type=big';
    displayNormal = displayUrl + '&type=normal';

    return (
      <a target="_blank" href={displayBig} rel="noreferrer">
        <img className="resultEntryImgNormal" src={displayNormal} />
      </a>
    );
  }
 
  // returning default image with no link
  return (
    <a target="_blank" href={displayBig} rel="noreferrer">
      <img onLoad={onImageLoad} className="resultEntryImgNormal" src={displayNormal} />
    </a>
  );

};

export default ResultMedia;